module.exports = __webpack_public_path__ + "static/orientation2-9b7c7acda2a3a11a310bcbda57c7c547.jpg";